import React from "react";
import PropTypes from "prop-types";

import "../styles/components/EmbeddedFrame.scss";

const EmbeddedFrame = ({ embeddedMediaUrl, title = "Shiftmed video" }) => {
    return (
        <div className="ratio ratio-16x9">
            <iframe
                loading="lazy"
                className="rounded"
                src={embeddedMediaUrl}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            ></iframe>
        </div>
    );
};

EmbeddedFrame.propTypes = {
    embeddedMediaUrl: PropTypes.string.isRequired,
    title: PropTypes.string,
};

export default EmbeddedFrame;
